<div class="videos-grid">
  @for (video of videos(); track video.url) {
    <div class="video-container">
      <div class="embed-responsive embed-responsive-16by9">
        <iframe class="embed-responsive-item"
                [src]="video.url | safeUrl"
                [title]="video.title"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
        </iframe>
      </div>
      <h5 style="color: #043c5a; text-align: center; text-transform: uppercase;">
        <b>{{ video.title }}</b>
      </h5>
      @if (video.powerpoint) {
        <a type="button" class="btn btn-primary btn-assessor" target="_blank" [href]="video.powerpoint">Presentation Slides</a>
      }
    </div>
  }
</div>
<ng-content></ng-content>
